import { render, staticRenderFns } from "./DownloadFileButton.vue?vue&type=template&id=b714bbd0&scoped=true"
import script from "./DownloadFileButton.vue?vue&type=script&lang=js"
export * from "./DownloadFileButton.vue?vue&type=script&lang=js"
import style0 from "./DownloadFileButton.vue?vue&type=style&index=0&id=b714bbd0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b714bbd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b714bbd0')) {
      api.createRecord('b714bbd0', component.options)
    } else {
      api.reload('b714bbd0', component.options)
    }
    module.hot.accept("./DownloadFileButton.vue?vue&type=template&id=b714bbd0&scoped=true", function () {
      api.rerender('b714bbd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/package/DownloadFileButton.vue"
export default component.exports